<template>
  <div class="customer-satisfaction-filter">
    <div class="customer-satisfaction-filter__left">
      <DropdownFilterWidget :selected="selectedRating" :options="ratingOptions" @onSelected="onSelectRating" />
      <DropdownFilterWidget :selected="selectedLanguage" :options="languageOptions" @onSelected="onSelectLanguage" />
      <DropdownFilterWidget :selected="selectedInquryResolved" :options="inquryResolvedOptions" @onSelected="onSelectInquiryResolved" />
    </div>
    <div class="search-input">
      <i class="bx bx-search" />
      <input
        placeholder="Search Respondent"
        class="search-input__input"
        @change="handleSearchInputChange"
      />
    </div>
    <button class="export-button" @click="handleExport">
      <i class="bx bx-export" />
      Export
    </button>
  </div>
</template>
<script>
import { debounce } from 'lodash';
import DropdownFilterWidget from './DropdownFilterWidget.vue';

const RATING_OPTIONS = [
  { label: 'All Rating', value: '' },
  { label: 'Very Satisfied', value: 4 },
  { label: 'Satisfied', value: 3 },
  { label: 'Dissatisfied', value: 2 },
  { label: 'Very Dissatisfied', value: 1 },
];

const LANGUAGES_OPTIONS = [
  { label: 'All Languages', value: '' },
  { label: 'Thai', value: 'TH' },
  { label: 'English', value: 'EN' },
];

const INQUIRY_RESOLVED_OPTIONS = [
  { label: 'All Inqury Resolved', value: '' },
  { label: 'Yes', value: 'YES' },
  { label: 'No', value: 'NO' },
];

export default {
  name: 'CustomerSatisfactionFilterWidget',
  components: { DropdownFilterWidget },
  data() {
    return {
      selectedRating: RATING_OPTIONS[0],
      selectedLanguage: LANGUAGES_OPTIONS[0],
      selectedInquryResolved: INQUIRY_RESOLVED_OPTIONS[0],
      ratingOptions: RATING_OPTIONS,
      languageOptions: LANGUAGES_OPTIONS,
      inquryResolvedOptions: INQUIRY_RESOLVED_OPTIONS,
      searchByRespondents: '',
    };
  },
  methods: {
    /** Convert empty or select all field to null in the 'selectedObject' 's value */
    prepareFilterValue(value) {
      if (typeof value === 'string' && value.length < 1) {
        return null;
      }
      return [value];
    },
    onSelectRating(selectedObject) {
      this.selectedRating = selectedObject;
      this.$emit('onChange', {
        field: 'score',
        value: this.prepareFilterValue(selectedObject.value),
      });
    },
    onSelectLanguage(selectedObject) {
      this.selectedLanguage = selectedObject;
      this.$emit('onChange', {
        field: 'language',
        value: this.prepareFilterValue(selectedObject.value),
      });
    },
    onSelectInquiryResolved(selectedObject) {
      this.selectedInquryResolved = selectedObject;
      this.$emit('onChange', {
        field: 'resolution_type',
        value: this.prepareFilterValue(selectedObject.value),
      });
    },
    handleSearchInputChange: debounce(function(e) {
      this.$emit('onChange', {
        field: 'username',
        value: this.prepareFilterValue(e.target.value),
      });
    }, 200),
    handleExport: debounce(function() {
      this.$emit('onExport');
    }, 200),
  },
};
</script>
<style lang="scss" scoped>
.customer-satisfaction-filter {
  display: flex;
  gap: 8px;
  padding-bottom: 24px;
  flex-wrap: wrap;
  &__left {
    display: flex;
    gap: 8px;
    flex: 1;
  }
  .search-input {
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #868ba6;
    padding: 8px 12px;
    border: 1px solid #dadce4;
    border-radius: 8px;
    background-color: #fff;
    outline: none;
    display: flex;
    align-items: center;
    width: 250px;
    cursor: pointer;
    i {
      color: #868ba6;
      margin-right: 8px;
      font-size: 20px;
    }
    &__input {
      height: 100%;
      width: 100%;
      outline: none;
      border: none;
    }
  }
  .export-button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    background-color: #3371ff;
    border: 0px;
    gap: 4px;
    color: #fff;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.32px;
    white-space: nowrap;
    padding: 8px 16px;
    height: 40px;
    > i {
      color: #fff;
    }
    i.bx {
      color: #fff;
    }
    &:not(:disabled):hover {
      box-shadow: 0px 2px 24px 0px rgba(51, 113, 255, 0.2);
      background-color: #2962df;
    }
    &:not(:disabled):active {
      background-color: #3371ff;
    }
    &:disabled {
      opacity: 0.65;
      background-color: #3371ff;
    }
  }
}
</style>
